import { render } from "./S93749.vue?vue&type=template&id=89b28136"
const script = {}
script.render = render

export default script